// extracted by mini-css-extract-plugin
export default {"container":"query-not-found_container__mc+gl","title":"query-not-found_title__6GevD","img":"query-not-found_img__5LY5B","btn":"query-not-found_btn__TH8Dh"};